import { Draft } from '@reduxjs/toolkit';
import {
  fulfilled,
  pending,
  rejected,
  requestReducer,
  RequestState,
} from 'features/shared/request';

interface CallState<T> {
  data?: T;
  request: RequestState;
}
export function onPending<T, M>(
  callState: Draft<CallState<T>>,
  meta: M,
  // set to false if you want to maintain the state (e.g. tab creation)
  // so that there's no need to re-fetch the data
  resetStateData = true
) {
  if (resetStateData) {
    callState.data = undefined;
  }
  callState.request = requestReducer(callState.request, pending({ meta }));
}

export function onRejected<T, M>(
  callState: Draft<CallState<T>>,
  meta: M,
  // set to false if you want to maintain the state
  resetStateData = true
) {
  if (resetStateData) {
    callState.data = undefined;
  }
  callState.request = requestReducer(callState.request, rejected({ meta }));
}

export function onFulfilled<M, T>(
  callState: Draft<CallState<T>>,
  meta: M,
  requestId: string | undefined,
  payload: Draft<T> | undefined
) {
  {
    if (callState.request.id === requestId) {
      callState.data = payload;
      callState.request = requestReducer(
        callState.request,
        fulfilled({ meta })
      );
    }
  }
}

export type FulfilledSideEffect<M, T, P> = (
  meta: M,
  callState: Draft<CallState<T>>,
  payload: P | undefined
) => void;

export function onFulfilledDo<M, T, P>(
  callState: Draft<CallState<T>>,
  meta: M,
  requestId: string | undefined = undefined,
  payload: P | undefined = undefined,
  sideEffect: FulfilledSideEffect<M, T, P> | undefined = undefined
) {
  if (callState.request.id === requestId) {
    callState.request = requestReducer(callState.request, fulfilled({ meta }));
    sideEffect?.call(undefined, meta, callState, payload);
  }
}
